import { RoleType } from '@wdx/clmi/clmi-swagger-gen';

export class RoleManagementService {
    static roles: RoleType[] = [];
}
